import React from 'react';
import { useTranslation } from 'react-i18next';
import { RegistrationUBNPSchema } from '../../form';
import OneValueCheckboxField from 'src/components/CheckboxField';
import { CheckboxWrapper, ConsentsInformation } from './index.styles';
import { Checkbox, FormControlLabel } from '@mui/material';
import { BNPRegistrationType } from '../../index';
import { useTranslationWithType } from '../../hooks';

export default function Consents(props: {
  form: RegistrationUBNPSchema;
  setForm: React.Dispatch<React.SetStateAction<RegistrationUBNPSchema>>;
  type: BNPRegistrationType;
}) {
  const { form, setForm, type } = props;
  const { t } = useTranslation();
  const tWithType = useTranslationWithType(type);

  const getConsentFields = () => {
    const baseFields = ['bnp_analytics'];
    if (type === 'sme_bnp') {
      baseFields.push('bnp_reports');
    }
    baseFields.push('bnp_representation');
    return baseFields;
  };

  return (
    <>
      <ConsentsInformation>
        {t('registration_bnp:consentsInformation')}
      </ConsentsInformation>
      {getConsentFields().map((field) => (
        <CheckboxWrapper key={field} sx={{ mt: '10px', mb: '10px' }}>
          <OneValueCheckboxField
            label=""
            value={form[field as keyof RegistrationUBNPSchema] as boolean}
            setValue={(value: boolean) => setForm({ ...form, [field]: value })}
          />
          <span
            dangerouslySetInnerHTML={{
              __html: t(`registration_bnp:form.${field}`),
            }}
            style={{
              fontSize: '12px',
              color: '#606462',
              lineHeight: '18px',
            }}
          />
        </CheckboxWrapper>
      ))}
      <span
        dangerouslySetInnerHTML={{
          __html: tWithType('dataProcessingInformation'),
        }}
        style={{
          fontSize: '8px',
          color: '#606462',
          lineHeight: '13px',
        }}
      />
    </>
  );
}
